import InitialState from 'Store/InitialState';
import { studentCourseGroupsActionTypes as types } from 'Screens_old';
import produce from 'immer';

export default function studentCourseGroupsReducer(state = InitialState.studentCourseGroupsMap, action) {
    switch (action.type) {
        case types.LOAD_STUDENT_COURSE_GROUPS_SUCCESS:
            let { courseid, groups } = action;

            return produce(state, (draftState) => {
                draftState[courseid] = groups;
            })

        case types.LOAD_STUDENT_COURSE_GROUPS_FAILURE:
            return state;

        default:
            return state;
    }
}